<template>
    <div class="col w-100">
        <div class="row justify-content-center w-100 pt-4">
            <pui-tabs
                :selected="currentTab"
                @changed="toggle"
            >
                <pui-tab
                    v-for="tab in tabs"
                    :key="tab"
                    :title="$t(tab)"
                />
            </pui-tabs>
        </div>
        <outage-clock v-if="currentTab === 0" />
        <outage-scorecard v-if="currentTab === 1" />
    </div>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component';
import OutageStrategyComponent from './scorecard/scorecard-component.vue';
import OutageClockComponent from './clock/outage-clock.vue';


@Component({
    name: 'outage-view',
    components: {
        'outage-clock': OutageClockComponent,
        'outage-scorecard': OutageStrategyComponent,
    }
})
export default class OutageView extends Vue {
    private tabs = ['outageClock', 'scorecard'];
    private currentTab = 0;


    constructor() {
        super();
    }

    private toggle(tab: number): void {
        this.currentTab = tab;
    }
}
</script>
